import { Button, Form, Modal, Popconfirm } from "antd";

import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import { SectionModel } from "../../../services/sections/models/section.model";
import {
  CreateTableModel,
  TableModel,
} from "../../../services/tables/models/tabele.model";
import CompManagerSectionAdd from "../sections/CompManagerSectionAdd";
import { useSelector } from "react-redux";
import { getCompanyId } from "../../../react-reduxs/slices/auth/auth_slice";
import FileUploadComponent from "../../tests/FileUploadComponent";
import { getCompany } from "../../../react-reduxs/slices/companies/company_slice";
import { TableService } from "../../../services/tables/table.service";
import { ApiUrl } from "../../../consts/api";
import { FileUploadService } from "../../../services/file_uploads/file_upload.service";
import { toast } from "react-toastify";
import ThemeDynamicForm from "@theme/ui-components/forms/ThemeDynamicForm";
import { RefType } from "@theme/ui-components/forms/form-field-type";
import { CompanyManagerTableFormFields } from "./CompMngrTableForms";
import ThemeButton from "@theme/ui-components/buttons/ThemeButton";
interface CompManagerTableAddProps {
  id?: string;
  sectionList: SectionModel[];
  add: (value: CreateTableModel) => void;
  addSection: (value: any) => void;
  getTableList?: () => Promise<void>;
  tableService: TableService;
  isLoading: boolean;
}
const CompManagerTableAdd: React.FC<CompManagerTableAddProps> = ({
  sectionList,
  add,
  addSection,
  id,
  tableService,
  getTableList,
  isLoading,
}) => {
  const formRef = useRef<RefType>();

  const fileUploadService = useMemo(() => new FileUploadService(), []);
  const companyId = useSelector(getCompanyId);
  const company = useSelector(getCompany);
  const [modalSectionAdd, setModalSectionAdd] = useState<boolean>(false);
  const [imageUrl, setImageUrl] = useState("");
  const [count, setCount] = useState(0);

  const onFinish = (values: any) => {
    if (companyId) {
      add({
        companyId: companyId,
        logo: imageUrl === "" ? undefined : imageUrl,
        id: id == "" ? null : id,
        ...values,
      });
    }
  };
  const getTable = useCallback(async () => {
    let response = await tableService.getById(id ?? "");
    if (response) {
      formRef.current?.setValues({
        id: response.id,
        name: response.name,
        number: response.number,
        sectionId: response.sectionId,
      });

      setImageUrl(response.logo);
    }
  }, [id, tableService]);
  const initialLoad = useCallback(() => {
    if (id !== "" && id !== undefined) {
      getTable();
    }
  }, [getTable, id]);

  useEffect(() => {
    setCount((cou) => {
      if (cou === 0) {
        initialLoad();
      }
      return 1;
    });
    return () => {};
  }, [initialLoad]);

  return (
    <div>
      <p className="text-lg">Masa Ekle</p>
      {imageUrl === "" || imageUrl === undefined ? (
        <FileUploadComponent
          setImageUrlParam={setImageUrl}
          path={"Companies/" + company?.folderName + "/Tables"}
        />
      ) : (
        <>
          <Popconfirm
            placement="left"
            okText={"Evet"}
            onConfirm={async () => {
              let response = await fileUploadService.deleteFile(imageUrl);

              if (response) {
                toast.success(response);
                let response2 = await tableService.update({
                  ...formRef.current?.values(),
                  logo: null,
                });
                setImageUrl("");
                if (response2) {
                  toast.success("Kayıt işlemi başarılı");
                  if (getTableList !== undefined) {
                    await getTableList();
                  }
                }
              }
            }}
            cancelText="Hayır"
            title="Fotoğraf silme işlemini onaylıyor musunuz?"
          >
            <Button
              loading={isLoading}
              disabled={isLoading}
              danger
              size="small"
              shape="circle"
              icon={<i className="fa-duotone fa-trash"></i>}
            />
          </Popconfirm>

          <img width={100} src={ApiUrl + "/" + imageUrl} alt="" />
        </>
      )}
      <ThemeDynamicForm
        ref={formRef}
        onFinish={(values) => onFinish(values)}
        fields={CompanyManagerTableFormFields(
          sectionList,
          isLoading,
          setModalSectionAdd,
        )}
        fieldClassName="col-12 md:col-6"
        initialValues={{ id: null, name: "", number: "0", sectionId: null }}
      />
      <ThemeButton
        label="Kaydet"
        icon="pi pi-save"
        onClick={() => {
          formRef.current?.submitForm();
        }}
      />
      {modalSectionAdd ? (
        <Modal
          title=""
          open={modalSectionAdd}
          okText={undefined}
          cancelText={undefined}
          onCancel={() => setModalSectionAdd(false)}
          styles={{ mask: { backdropFilter: "blur(10px)" } }}
          footer={<></>}
        >
          <CompManagerSectionAdd
            closeModal={() => {
              setModalSectionAdd(false);
            }}
            isLoading={isLoading}
            addSection={addSection}
          />
        </Modal>
      ) : (
        <></>
      )}
    </div>
  );
};

export default CompManagerTableAdd;
